export class CompletionAnswer {
  static readonly Yes = 'YES';
  static readonly No = 'NO';
  static readonly NotApplicable = 'NA';

  static readonly NoAnswer = 'NONE';

  static getTranslationKey(completedCorrectly: string): string {
    switch (completedCorrectly) {
      case CompletionAnswer.Yes: return 'generic_text_yes';
      case CompletionAnswer.No: return 'generic_text_no';
      case CompletionAnswer.NotApplicable: return 'generic_text_not_applicable';
      default: return 'report_completion_no_answer';
    }
  }
}
